;
/*!
 * subitotexto.courrier-submit.js
 */


SubitoTexto.courrierSubmit = {
	init       : function () {
		var $ = jqPla,
			_this = SubitoTexto.courrierSubmit;

		// Also serves to check if we're in the right place.
		_this.$mainContainer = $( '.courrier-submit-container' );


		if ( _this.$mainContainer.length < 1 ) {
			// Nothing to do on this page
			return;
		}


		if ( typeof CONFIG == 'undefined' || typeof CONFIG.courrier_submit_url == 'undefined' ) {
			console.error( '[SubitoTexto.courrierSubmit] Need the  CONFIG.courrier_submit_url  path' );
		}


		new Fingerprint2( {
			excludeAvailableScreenResolution: true,
			excludeScreenResolution         : true
		} ).get( function ( result, components ) {
			_this.fingerprint = result;
		} );


		_this.$btnFormToggler = _this.$mainContainer.find( '.btn-courrier-form-toggler' );
		_this.$form = _this.$mainContainer.find( '.form-courrier-submit' );
		_this.$messageSuccess = _this.$mainContainer.find( '.message-success' );

		_this.bindEvents();

	},
	bindEvents : function () {
		var $ = jqPla,
			_this = SubitoTexto.courrierSubmit;


		_this.$btnFormToggler.on( 'click', function ( e ) {

			var $this = $( this ),
				isActive = !$this.hasClass( 'disabled' );

			if ( isActive ) {
				_this.toggleForm( $( this ) );
			}

		} );


		_this.$form.on( 'reset', function ( e ) {
			_this.resetForm();
		} );


		_this.$form.on( 'submit', function ( e ) {
			e.preventDefault();

			_this.processForm();
		} );
	},
	toggleForm : function ( $clicked, forceReset ) {
		var $ = jqPla,
			_this = SubitoTexto.courrierSubmit;

		if ( $clicked.hasClass( 'active' ) || forceReset ) {
			$clicked.removeClass( 'active' );
			_this.$form
				.removeClass( 'form-open' )
				.attr( 'aria-hidden', 'true' );
			;

			_this.$form.find( 'input, textarea' ).attr( 'tabindex', -1 );

		} else {
			$clicked.addClass( 'active' );
			_this.$form
				.addClass( 'form-open' )
				.attr( 'aria-hidden', 'false' );

			_this.$form.find( 'input, textarea' ).attr( 'tabindex', 0 );

			// Make sure the form is on screen when we try to open it
			if ( PLA.UTILS.areWeMobile() ) {
				PLA.UTILS.scrollTop.scrollTo( _this.$form, -20 );
			}
		}

	},
	resetForm  : function () {
		var $ = jqPla,
			_this = SubitoTexto.courrierSubmit;

		_this.toggleForm( _this.$btnFormToggler, true );
		_this.$messageSuccess.hide();
		$( '.form-submission-results' ).html();


		if ( $( window ).width() < 1200 ) {
			PLA.UTILS.scrollTop.scrollTo( $( '.courrier-intro-main' ), -40 );
		}

	},
	processForm: function () {
		var $ = jqPla,
			_this = SubitoTexto.courrierSubmit;


		$.ajax( {
			url     : CONFIG.courrier_submit_url,
			dataType: 'json',
			type    : 'post',
			data    : _this.$form.serialize() + "&fingerprint=" + _this.fingerprint
		} )
			.done( function ( _data ) {

				if ( typeof _data.success == 'undefined' || _data.success != 1 ) {
					// problem

					SubitoTexto.form.processForm( _this.$form, _data.errors, true );

				} else {
					// success!

					_this.$form.slideUp('fast');

					_this.$messageSuccess.find( 'p' ).slideDown( function () {
						PLA.UTILS.scrollTop.scrollTo( _this.$messageSuccess, -40 );
					} );


					_this.$btnFormToggler.addClass( 'disabled' );
				}

			} );

	}


};

